import { IApplicationData } from "models/application-data";
import { IMenuResponse } from "models/response/menu-response";
import { PaginationResponse } from "models/pagination-response";
import { INewsPagedRespomse } from "models/response/news-paged-response";
import { ILinkServicesListResponse } from "models/response/link-services-list-response";
import { IBannersListResponse } from "models/response/banners-list-response";

export type AppState = {
    applicationData: IApplicationData | undefined;
    menus: IMenuResponse[];
    menusLoading: boolean;
    menusError: boolean;
    homeData: {
        news: PaginationResponse<INewsPagedRespomse> | undefined;
        linkServices: ILinkServicesListResponse[] | undefined;
        banners: IBannersListResponse[] | undefined;
    };
};

export enum ACTION_TYPES {
    setApplicationData = 'setApplicationData',
    setMenus = 'setMenus',
    setMenusLoading = 'setMenusLoading',
    setMenusError = 'setMenusError',
    setHomeNews = 'setHomeNews',
    setHomeLinkServices = 'setHomeLinkServices',
    setHomeBanners = 'setHomeBanners',
}

export const AppReducer = (state: AppState, action: any): AppState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setApplicationData:
            return {
                ...state,
                applicationData: payload,
            };
        case ACTION_TYPES.setMenus:
            return {
                ...state,
                menus: payload,
                menusLoading: false,
                menusError: false,
            };
        case ACTION_TYPES.setMenusLoading:
            return {
                ...state,
                menusLoading: payload,
            };
        case ACTION_TYPES.setMenusError:
            return {
                ...state,
                menusError: payload,
                menusLoading: false,
            };
        case ACTION_TYPES.setHomeNews:
            return {
                ...state,
                homeData: {
                    ...state.homeData,
                    news: payload,
                },
            };
        case ACTION_TYPES.setHomeLinkServices:
            return {
                ...state,
                homeData: {
                    ...state.homeData,
                    linkServices: payload,
                },
            };
        case ACTION_TYPES.setHomeBanners:
            return {
                ...state,
                homeData: {
                    ...state.homeData,
                    banners: payload,
                },
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}